export enum DIRECTORIES_ADMIN {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618838003
     */
    ALL_DIRECTORIES = 'DIRECTORIES_ADMIN.ALL_DIRECTORIES',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618839125
     */
    DELETE_DIRECTORY = 'DIRECTORIES_ADMIN.DELETE_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=618839369
     */
    DELETE_DIRECTORY_DESCRIPTION = 'DIRECTORIES_ADMIN.DELETE_DIRECTORY_DESCRIPTION',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=619855191
     */
    NEW_DIRECTORY = 'DIRECTORIES_ADMIN.NEW_DIRECTORY',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=627024318
     */
    CUSTOM_FIELDS_AVAILABLE = 'DIRECTORIES_ADMIN.CUSTOM_FIELDS_AVAILABLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13452217
     */
    CAN_ADD_NEW_ENTRIES = 'ADMIN_MODULE_DIRECTORY_SETTINGS_FAVORITES_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=627024898
     */
    METADATA_AVAILABLE = 'DIRECTORIES_ADMIN.METADATA_AVAILABLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=627025892
     */
    LOCAL_ENTRIES = 'DIRECTORIES_ADMIN.LOCAL_ENTRIES',
}
